module.exports = {
        menu: [
            { nodeEnv: 'production_a', apiUrl: 'https://211.100.61.212' },
            { nodeEnv: 'production_b', apiUrl: 'http://b.com' },
            { nodeEnv: 'test', apiUrl: 'http://ceshiwangzhi.com' },
            { nodeEnv: 'development', apiUrl: 'https://211.100.61.212' },

        ],
    }
    //    https://211.100.61.209
    //    https://211.100.61.211
    //    https://211.100.47.36   https://192.168.3.190